import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import Loading from "../Loading";
import BrowseFiltersBooksArabic from "./BrowseFiltersBooksArabic";

import theme from "../../styles/theme";
import PdfViewerModalArabic from "./PdfViewerModalArabic";
import calendar from "../../assets/icons/calendar.svg";
import compass from "../../assets/icons/compass.svg";
// REMOVED:import FeedbackPopupArabic from "./FeedbackPopupArabic";
import "../../styles-arabic/search-results.rtl.css";

import {
  convertToArabicDate,
  toArabicNumber,
} from "../../utils/arabicConversions";

import PageNumbersArabic from "./PageNumbersArabic";
import useBrowseResults from "../../custom-hooks/useBrowseResults";

const PAGINATION_RANGE = 2;

const BrowseResultsBooksArabic = () => {
  const {
    browseResults,
    setBrowseResults,
    loading,
    setLoading,
    currentPage,
    setCurrentPage,
    totalPages,
    displayedRows,
    handlePageChange,
    modalOpen,
    selectedRow,
    handleRowClick,
    handleCloseModal,
    showFeedbackPopup,
    handleCloseFeedbackPopup,
    fingerprint,
    isNewUser,
  } = useBrowseResults();

  return (
    <>
      <Loading isLoading={loading}>
        <div
          style={{
            background: theme.colors.mainGrayBackground,
            width: "100%",
          }}
        >
          <Header />
          <div>
            {/* <SearchInput
              searchString={searchString}
              setSearchResults={setSearchResults}
              setAnalytics={setAnalytics}
              setCurrentPage={setCurrentPage}
              setLoading={setLoading}
            /> */}
            <BrowseFiltersBooksArabic
              setBrowseResults={setBrowseResults}
              setCurrentPage={setCurrentPage}
              setLoading={setLoading}
            />
          </div>
          {browseResults && browseResults.length > 0 && (
            <div className="row g-0 mt-4 ml-2 mr-2">
              <div className="col g-0" style={{ margin: "0 15px" }}>
                <div className="row g-0">
                  <table className="arabic-table" dir="rtl">
                    <colgroup>
                      <col style={{ width: "14%" }} />
                      <col style={{ width: "14%" }} />
                      <col style={{ width: "14%" }} />
                      <col style={{ width: "14%" }} />
                      <col style={{ width: "14%" }} />
                      <col style={{ width: "15%" }} />
                      <col style={{ width: "15%" }} />
                    </colgroup>
                    <thead className="arabic-table-head">
                      <tr>
                        <th className="arabic-table-th">العنوان</th>
                        <th className="arabic-table-th">التاريخ</th>
                        <th className="arabic-table-th">مكان النشر</th>
                        <th className="arabic-table-th">الناشر</th>
                        <th className="arabic-table-th">المجلد</th>
                        <th className="arabic-table-th">اللغة</th>
                        <th className="arabic-table-th">المؤلفون</th>
                      </tr>
                    </thead>
                    <tbody>
                      {displayedRows.map((row, index) => (
                        <React.Fragment key={index}>
                          <tr
                            onClick={() => handleRowClick(row)}
                            style={{
                              borderBottom: "1px solid #E5E5E5",
                              cursor: "pointer",
                            }}
                          >
                            <td className="arabic-ellipsis arabic-title-text">
                              {row.title_arabic}
                            </td>
                            <td>
                              <img
                                src={calendar}
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  marginLeft: "5px",
                                }}
                                alt="Calendar Icon"
                              />
                              {convertToArabicDate(row.date_of_publication)}
                            </td>
                            <td className="arabic-ellipsis">
                              <img
                                src={compass}
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  marginLeft: "5px",
                                }}
                                alt="Compass Icon"
                              />
                              {row.place_of_publication_arabic}
                            </td>
                            <td className="arabic-ellipsis">
                              {row.publisher_arabic}
                            </td>
                            <td>{toArabicNumber(row.volume.toString())}</td>
                            <td>{row.language}</td>
                            <td className="arabic-ellipsis">
                              {row.authors_arabic}
                            </td>
                          </tr>
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                </div>
                <PdfViewerModalArabic
                  className="pdf-viewer-modal"
                  show={modalOpen}
                  handleClose={handleCloseModal}
                  searchQuery={""}
                  row={selectedRow}
                />
                <div className="row mt-5 mb-5 g-0">
                  <div className="d-flex justify-content-center">
                    <PageNumbersArabic
                      currentPage={currentPage}
                      totalPages={totalPages}
                      handlePageChange={handlePageChange}
                      PAGINATION_RANGE={PAGINATION_RANGE}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* {isNewUser !== null && isNewUser && (
          <FeedbackPopupArabic
            show={showFeedbackPopup}
            handleClose={handleCloseFeedbackPopup}
            fingerprint={fingerprint}
          />
        )} */}
        <Footer bgcolor="#FFFFFF" />
      </Loading>
    </>
  );
};

export default BrowseResultsBooksArabic;
